import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {Route, Routes, Outlet, Navigate} from "react-router-dom";
// import LogPage from "../../pages/logPage";
import AuthHeader from "../authHeader";
import AuthFooter from "../authFooter";
import CabinetHeader from "../cabinetHeader";
import CabinetFooter from "../cabinetFooter";
import LaunchpadPage from "../../pages/launchpadPage";
import LaunchpadProjectsAllPage from "../../pages/launchpadProjectsAllPage";
import LaunchpadProjectPage from "../../pages/launchpadProjectPage";
import RegPage from "../../pages/regPage";
import {useDispatch, useSelector} from "react-redux";
import {getUserData} from "../../store/cabinet/action";
import SettingsPage from "../../pages/settingsPage";
import LaunchpadFreezeHistoryPage from "../../pages/launchpadFreezeHistoryPage";
import AcademyWarning from "../academyWarning";
import AboutPage from "../../pages/aboutPage";
import ApplyForIdoPage from "../../pages/applyForIdoPage";
import ApplyFormPage from "../../pages/applyFormPage";
import AcademyPage from "../../pages/academyPage";
import CabinetComingSoon from "../cabinetComingSoon";
import LaunchpadPreviewPage from "../../pages/launchpadPreviewPage";


const AuthenticationLayout = () => (
    <div className={`${Styles.authentication}`}>
        <AuthHeader/>
        <Outlet />
        <AuthFooter/>
    </div>
);

const CabinetLayout = () => {
    const userData = useSelector((store) => store.cabinet.userData);

    const warningHandler = () =>{
        if (userData?.user?.is_honee){
            if (userData?.user?.academy_bought){
                return <Outlet />
            } else {
                return <AcademyWarning />
            }
        } else {
            return <Outlet />
        }
    }

    return (
        <div className={Styles.cabinet}>
            <div className={Styles.posWrap}>
                <CabinetHeader />
                <div className={`${Styles.cabinetWrap} ${Styles.pageContainer}`}>
                    {warningHandler()}
                </div>
                <CabinetFooter />
            </div>
        </div>
    );
};



const App = () => {
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);
    const isComingSoon = useSelector(store => store.main.isComingSoon);

    useEffect(()=>{
        if(authStatus){
            dispatch(getUserData());
        }
    },[authStatus, dispatch])

    return (
        <section className={`${Styles.container}`}>
            <Routes>
                <Route element={<AuthenticationLayout/>}>
                    {/*<Route exact path='/' element={<MainPage/>}/>*/}
                    {/*<Route exact path='/sign-in' element={<LogPage/>}/>*/}
                    <Route exact path='/sign-up' element={<RegPage/>}/>
                    <Route exact path='/sign-up/:code' element={<RegPage/>}/>
                    <Route exact path='/about' element={<AboutPage/>}/>
                    <Route exact path='/apply-for-ido' element={<ApplyForIdoPage/>}/>
                    <Route exact path='/apply-form' element={<ApplyFormPage/>}/>
                    <Route exact path='/omt-academy' element={<AcademyPage/>}/>
                </Route>
                <Route element={<CabinetLayout/>}>
                    <Route exact path='/launchpad' element={isComingSoon ? <CabinetComingSoon/> : <LaunchpadPage/>}/>
                    <Route exact path='/freeze-history' element={isComingSoon ? <CabinetComingSoon/> : <LaunchpadFreezeHistoryPage/>}/>
                    <Route exact path='/projects' element={<LaunchpadProjectsAllPage/>}/>
                    <Route exact path='/projects/:id' element={isComingSoon ? <CabinetComingSoon/> : <LaunchpadProjectPage/>}/>
                    <Route exact path='/profile' element={<SettingsPage/>}/>
                    <Route exact path={`/${process.env.REACT_APP_PREVIEW_ID}/:id`} element={<LaunchpadPreviewPage/>}/>
                </Route>
                <Route path="*" element={<Navigate to="/sign-up" replace />} />
            </Routes>
            <ToastContainer/>
        </section>
    );
};

export default App;